import { css } from 'styled-components';

// Text tint toggle: true = warmer tint, false = lighter/subtler tint.
const useWarmerTextTint = false;

const variables = css`
  :root {
    --dark-navy: #020c1b;
    --navy: #0a192f;
    --nav-background: rgba(10, 25, 47, 0.85);
    --light-navy: #112240;
    --lightest-navy: #233554;
    --navy-shadow: rgba(2, 12, 27, 0.7);
    --dark-slate: #495670;
    --slate: #979db2;
    --light-slate: #a8b2d1;
    --lightest-slate: #ccd6f6;
    --white: #e6f1ff;
    --green: #64ffda; // the original green
    --link-text: #d5dfed;
    // --green: var(--light-navy);   // not actually green, just easier to change this variable
    --green-tint: rgba(100, 255, 218, 0.1); // same idea with green
    --pink: #f57dff;
    --blue: #57cbff;

    /* Loading screen and neon sign colors. */
    --loader-background: var(--dark-navy);
    --neon-wire-dark: #1e2a34;
    --neon-wire-light: #537166;
    --neon-wire-ring: #69877b;
    --neon-glass-edge: #9fc7bb;
    --neon-core: #c5ffed;
    --neon-clips: #34483f;
    --neon-glass-1: #182b26;
    --neon-glass-2: #598f7e;
    --neon-glass-3: #213830;
    --neon-glass-4: #4d7568;
    --neon-glass-5: #1b2924;
    --neon-gas-light: #a6ffe7;
    --neon-gas-mid: #98ffe1;

    --font-sans: 'Calibre', 'Inter', 'San Francisco', 'SF Pro Text', -apple-system, system-ui,
      sans-serif;
    --font-mono: 'SF Mono', 'Fira Code', 'Fira Mono', 'Roboto Mono', monospace;

    --fz-xxs: 12px;
    --fz-xs: 13px;
    --fz-sm: 14px;
    --fz-md: 16px;
    --fz-lg: 18px;
    --fz-xl: 20px;
    --fz-xxl: 22px;
    --fz-heading: 32px;

    --border-radius: 4px;
    --nav-height: 100px;
    --nav-scroll-height: 70px;

    --tab-height: 52px;
    --tab-width: 120px;

    --easing: cubic-bezier(0.645, 0.045, 0.355, 1);
    --transition: all 0.25s cubic-bezier(0.645, 0.045, 0.355, 1);

    --hamburger-width: 30px;

    --ham-before: top 0.1s ease-in 0.25s, opacity 0.1s ease-in;
    --ham-before-active: top 0.1s ease-out, opacity 0.1s ease-out 0.12s;
    --ham-after: bottom 0.1s ease-in 0.25s, transform 0.22s cubic-bezier(0.55, 0.055, 0.675, 0.19);
    --ham-after-active: bottom 0.1s ease-out,
      transform 0.22s cubic-bezier(0.215, 0.61, 0.355, 1) 0.12s;
  }
  /* Experimental palette: warm charcoal + amber.
     Edit these colors to experiment. Remove this :root block to restore
     the original palette above. Existing variable names keep their roles. */
  :root {
    --dark-navy: #141210;
    --navy: #1a1815;
    --nav-background: rgba(26, 24, 21, 0.85);
    --light-navy: #2c2722;
    --lightest-navy: #443b32;
    --navy-shadow: rgba(20, 18, 16, 0.7);
    --dark-slate: #76695c;
    /* Comment out individual text-color overrides to use the original cool grays above.
       Uncomment them to restore the warm tint. */
    --slate: ${useWarmerTextTint ? '#b9ad9f' : '#b0ada9'}; /* Body text */
    --light-slate: ${useWarmerTextTint ? '#d0c4b6' : '#c7c4c0'}; /* Secondary text */
    --lightest-slate: ${useWarmerTextTint ? '#e9dfd2' : '#e2dfdc'}; /* Most headings */
    --white: ${useWarmerTextTint ? '#fff5e8' : '#f8f5f2'}; /* Bright text / blog titles */
    --green: #efbb73;
    --link-text: ${useWarmerTextTint ? '#ead9c3' : '#dedad5'}; /* Links */
    --green-tint: rgba(239, 187, 115, 0.1);
    --pink: #e8a1b0;
    --blue: #91bdcf;

    /* Loading screen and neon sign colors. */
    --loader-background: #000000;
    --neon-wire-dark: #302820;
    --neon-wire-light: #806a4d;
    --neon-wire-ring: #a18a68;
    --neon-glass-edge: #d6bc95;
    --neon-core: #fff0d5;
    --neon-clips: #514332;
    --neon-glass-1: #30251a;
    --neon-glass-2: #a18350;
    --neon-glass-3: #463522;
    --neon-glass-4: #876b43;
    --neon-glass-5: #30271d;
    --neon-gas-light: #ffe0ac;
    --neon-gas-mid: #f7d198;
  }
`;

export default variables;
